import {Route, Routes, Outlet} from 'react-router-dom'
import PricingListWrapper from './pricing/list/ListWrapper'
import TrxListWrapper from './transaction/list/ListWrapper'

const PaymentPage = () => (
  <Routes>
    <Route element={<Outlet />}>
      <Route path='/pricing' element={<PricingListWrapper />} />
      <Route path='/transaction' element={<TrxListWrapper />} />
    </Route>
  </Routes>
)

export default PaymentPage
